import ChartAdapterStore from 'src/store/ChartAdapterStore';

type TCreateChartElementProps = {
    onChartLoad: ChartAdapterStore['onChartLoad'];
};

export const createChartElement = ({ onChartLoad }: TCreateChartElementProps) => {
    console.log('[createChartElement] Starting...');
    // Chart element is set in a window element for faster initialization
    if (window.flutterChartElement) {
        console.log('[createChartElement] Flutter element already exists, calling onChartLoad');
        onChartLoad();
        return;
    }

    setupListeners();

    // Create an iframe to host the Flutter mini-site under /flutter/
    const iframe = document.createElement('iframe');
    iframe.classList.add('flutter-chart');
    iframe.src = '/flutter/';
    iframe.style.width = '100%';
    iframe.style.height = '100%';
    iframe.style.border = '0';
    console.log('[createChartElement] Created iframe with src=/flutter/');

    // Expose iframe as the expected global element
    window.flutterChartElement = iframe as unknown as HTMLDivElement;

    // Minimal _flutter shape to satisfy existing code paths
    (window as any)._flutter = {
        initState: {
            isInitialRunCompleted: false,
            isEngineIntialized: true,
            isMounted: false,
        },
    };

    iframe.addEventListener('load', () => {
        console.log('[createChartElement] iframe loaded');
        // Nudge the child to (re)bind jsInterop as soon as it is ready
        try {
            iframe.contentWindow?.postMessage({ type: 'provide-js-interop' }, window.location.origin);
            console.log('[createChartElement] Sent provide-js-interop message to iframe');
            // Send again shortly after in case the listener attached a tad later
            setTimeout(() => {
                try {
                    iframe.contentWindow?.postMessage({ type: 'provide-js-interop' }, window.location.origin);
                } catch {}
            }, 100);
        } catch (e) {
            console.log('[createChartElement] Error sending message to iframe:', e);
        }
        // Do not call onChartLoad here; wait for the child to invoke jsInterop.onChartLoad
    });

    return window.flutterChartElement;
};

const setupListeners = () => {
    const listener = (ev: KeyboardEvent) => {
        // To fix a trackjs issue caused by some keyboard events that don't contain `key` or `code` props.
        // https://github.com/flutter/engine/blob/f20657354d8b53baafcec55650830ead89adf3e9/lib/web_ui/lib/src/engine/keyboard_binding.dart#L386
        if (!ev.key || !ev.code) {
            ev.stopImmediatePropagation();
        }
    };

    window.addEventListener('keydown', listener, true);
    window.addEventListener('keyup', listener, true);
};

export const runChartApp = () => {
    if (window._flutter.initState.isMounted) {
        // Flutter app inside iframe boots on its own
        window._flutter.initState.isInitialRunCompleted = true;
    }
};
